import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function PageContent({ children }: Props) {
  return <div style={{ marginTop: 10 }}>{children}</div>;
}
